import { MdDelete } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { University_WebsiteDetails_Table } from "../../Models/universityWebDetailsModel";
import { useDispatch, useSelector } from "react-redux";
import { UNIVERSITYWEB_DETAILS_SINGLE_DATA } from "../../Actions/universityWebDetailsAction";

export default function UniversityWebTableRow({
  Id,
  universityId,
  University_Name,
  aboutUniversity,
  commonApplicationFee,
  degreeOffered,
  extraDetails,
  googleMapUrl,
  neighborhood,
  commonTuitionFees,
  universityDetails,
  whyText,
  handleEditUniversityWebDetails,
  handleDeleteUniversityWebDetails,
}) {
  const data = [
    "delete",
    University_Name,
    commonApplicationFee,
    degreeOffered,
    commonTuitionFees,
    googleMapUrl,
    neighborhood,
    universityDetails,
  ];

  const handleEdit = (e) => {
    e.preventDefault();
    handleEditUniversityWebDetails("data passing", {
      Id,
      universityId,
      commonApplicationFee,
      degreeOffered,
      googleMapUrl,
      neighborhood,
      commonTuitionFees,
      universityDetails,
      whyText,
      extraDetails,
      aboutUniversity,
    });
  };

  // Handle Delete Table function
  const handleDelete = (e) => {
    e.preventDefault();
    handleDeleteUniversityWebDetails(Id);
  };

  return (
    <tr>
      {University_WebsiteDetails_Table?.map((el, i) => (
        <td key={i} >
          {data[i] === "delete" ? (
            <span  className={data[i] === "delete" ? "Edit_Delete" : ""}>
              <span onClick={(e)=>handleEdit(e)}>
                <TbEdit />
              </span>
              <span onClick={handleDelete}>
                <MdDelete />
              </span>
            </span>
          ) : (
            data[i]
          )}
        </td>
      ))}
    </tr>
  );
}
